import { config } from "@/config/eventConfig";

// Prompt School part 1: the R-T-C-F teaching screen. A two-by-two grid of the
// four elements; text and examples read from config for per-event localisation.
export const RtcfGrid = () => {
  const { elements, missing_c_line } = config.rtcf;

  return (
    <div data-testid="rtcf-grid">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {elements.map((el) => (
          <div
            key={el.letter}
            data-testid={`rtcf-card-${el.letter}`}
            className="bg-white border border-sand p-6"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="w-9 h-9 bg-teal text-white font-display text-xl leading-none flex items-center justify-center shrink-0">
                {el.letter}
              </span>
              <span className="text-lg font-semibold">{el.name}</span>
            </div>
            <p className="text-ink/70 mb-4">{el.definition}</p>
            <div className="border-l-2 border-sand pl-4">
              <p className="italic text-ink/60">{el.example}</p>
            </div>
          </div>
        ))}
      </div>

      <p data-testid="rtcf-missing-c" className="text-ink mt-8">
        {missing_c_line}
      </p>
    </div>
  );
};
